import React, { useEffect } from 'react';
import ShopOnlyPhotoLocVerification from '@/pages/ShopOnlyPhotoLocVerification';

interface ShopPhotoCaptureProps {
  value?: any;
  onChange?: (data: any) => void;
  onDone?: () => void;
}

/**
 * Wrapper component for ShopOnlyPhotoLocVerification page
 * to make it compatible with the journey builder system.
 * 
 * This component wraps the full-featured shop photo capture page which includes:
 * - Business address validation and display
 * - GPS distance checking from business location
 * - Camera permission handling (back camera preferred)
 * - Multi-screen flow (instructions, capture, review, upload)
 * - Error handling and retry mechanisms
 */
export default function ShopPhotoCapture({ value, onChange, onDone }: ShopPhotoCaptureProps) {
  // The existing page component handles everything internally
  // It will automatically advance the journey after successful upload
  // We just need to render it and let it do its thing
  
  useEffect(() => {
    // If we already have a captured photo in value, we could skip
    // But the page handles its own state, so we let it run
    console.log('[ShopPhotoCapture] Wrapper mounted', { value });
  }, [value]);

  // The existing page component doesn't accept props for onDone
  // It handles journey advancement internally via JourneyContext
  // So we just render it as-is
  return <ShopOnlyPhotoLocVerification />;
}
